import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Loader } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, MiniTable } from "@/components/vi/TourParts";
import Recommendations, { RecoHeader } from "@/components/vi/Recommendations";
import { FileDown } from "lucide-react";
import { money, downloadBlob } from "@/lib/vi";

const iso = (d) => d.toISOString().slice(0, 10);
function presetRange(p) {
  const t = new Date();
  if (p === "jour") return [iso(t), iso(t)];
  if (p === "semaine") { const s = new Date(t); s.setDate(t.getDate() - ((t.getDay() + 6) % 7)); return [iso(s), iso(t)]; }
  return [iso(new Date(t.getFullYear(), t.getMonth(), 1)), iso(t)];
}

export function ViProfitability() {
  const [group, setGroup] = useState("tricycle");
  const [[start, end], setRange] = useState(presetRange("mois"));
  const [d, setD] = useState(null);
  const qs = `group=${group}&start=${start}&end=${end}`;
  useEffect(() => { setD(null); api.get(`/itinerant/profitability?${qs}`).then((r) => setD(r.data)); }, [qs]);
  const best = d?.rows[0]?.id;
  const worst = d?.rows.length > 1 ? d.rows[d.rows.length - 1].id : null;
  return (
    <div data-testid="vi-profitability">
      <PageHeader title="Rentabilité" subtitle="CA − coût marchandises − carburant − dépenses − entretien − commissions = résultat">
        <Button variant="outline" onClick={() => downloadBlob(`/itinerant/profitability/pdf?${qs}`, `rentabilite-${group}.pdf`)} data-testid="profit-pdf"><FileDown className="h-4 w-4 mr-1.5" />PDF</Button>
      </PageHeader>
      <div className="flex flex-wrap items-end gap-2 mb-4">
        {[["tricycle", "Par tricycle"], ["circuit", "Par circuit"]].map(([k, l]) => <Button key={k} variant={group === k ? "default" : "outline"} className={group === k ? "bg-brand-600 text-white" : ""} onClick={() => setGroup(k)} data-testid={`profit-tab-${k}`}>{l}</Button>)}
        <span className="w-4" />
        {[["jour", "Jour"], ["semaine", "Semaine"], ["mois", "Mois"]].map(([k, l]) => <Button key={k} size="sm" variant="outline" onClick={() => setRange(presetRange(k))} data-testid={`profit-preset-${k}`}>{l}</Button>)}
        <Input type="date" className="w-40" value={start} onChange={(e) => setRange([e.target.value, end])} data-testid="profit-start" />
        <Input type="date" className="w-40" value={end} onChange={(e) => setRange([start, e.target.value])} data-testid="profit-end" />
      </div>
      {!d ? <Loader /> : (
        <Card title={`${group === "tricycle" ? "Tricycles" : "Circuits"} — ${d.start} → ${d.end}`} testid="profit-table">
          <MiniTable head={[group === "tricycle" ? "Tricycle" : "Circuit", "Tournées", "CA", "Coût march.", "Marge brute", "Taux", "Carburant", "Autres dép.", "Entretien", "Commissions", "Résultat", "CA/km"]}
            rows={[...d.rows.map((r) => [<span key="l" className={r.id === best ? "font-bold text-emerald-700" : r.id === worst ? "font-bold text-rose-600" : ""}>{r.label}</span>,
              r.tournees, money(r.ca), money(r.cout_marchandises), money(r.marge_brute), r.taux_marge == null ? "—" : `${r.taux_marge} %`, money(r.carburant), money(r.autres_depenses),
              money(r.entretien), money(r.commissions), <b key="r" className={r.resultat < 0 ? "text-rose-600" : "text-emerald-700"} data-testid={`profit-result-${r.label}`}>{money(r.resultat)}</b>, r.ca_par_km == null ? "—" : money(r.ca_par_km)]),
              ...(d.rows.length ? [[<b key="t">TOTAL</b>, "", money(d.totaux.ca), money(d.totaux.cout_marchandises), money(d.totaux.marge_brute), "", money(d.totaux.carburant), money(d.totaux.autres_depenses),
                money(d.totaux.entretien), money(d.totaux.commissions), <b key="r" data-testid="profit-total">{money(d.totaux.resultat)}</b>, ""]] : [])]} />
          <p className="text-[11px] text-slate-400 mt-2">{d.note}</p>
        </Card>
      )}
    </div>
  );
}

export function ViRecommendations() {
  return (
    <div data-testid="vi-recommendations">
      <PageHeader title="Clients à visiter" subtitle="Inactifs (> 30 jours), fort potentiel, crédits échus, prospects chauds — avec produits à proposer" />
      <Card title={<RecoHeader />}><Recommendations /></Card>
    </div>
  );
}
